import { useDispatch } from 'react-redux'

import { apiZodios } from '~api/apiZodios'
import outlookZodios from '~api/outlookApiZodios'
import { type User } from '~types'

import { loginUser, logoutUser, setUnauthenticated } from '../redux/slices/authSlice'
import { type AppDispatch } from '../redux/store'

export const useFetchCreds = (): {
  fetchUserCredentials: (userId: string | null, user: User | null) => Promise<boolean>
} => {
  const dispatch: AppDispatch = useDispatch()

  const fetchUserCredentials = async (
    userId: string | null,
    user: User | null,
  ): Promise<boolean> => {
    try {
      const isOutlook = typeof window !== 'undefined' && window.Office !== undefined

      let resolvedUserId = userId
      if (!resolvedUserId && !isOutlook) {
        const { data } = await apiZodios.core_getUserFromSession({})
        resolvedUserId = data
      }

      if (!resolvedUserId) {
        dispatch(logoutUser())
        return false
      }

      if (!user || !user.logged_in || resolvedUserId != user.id) {
        const getUserFn = isOutlook ? outlookZodios.getUser : apiZodios.core_getUser
        const user = await getUserFn({ user_id: resolvedUserId })
        if (user.logged_in) {
          dispatch(loginUser(user))
          return true
        } else {
          dispatch(setUnauthenticated())
        }
      }
    } catch (_error) {
      dispatch(setUnauthenticated())
    }
    return false
  }

  return { fetchUserCredentials }
}
